import React, { useState, useEffect } from "react";
import moment from "moment";

const CalendarHome = ({ onDateSelect }) => {
  const today = moment().format("YYYY-MM-DD");
  const [selectedDate, setSelectedDate] = useState(today);
  const [slideD, setSlideD] = useState([]);
  const [activeIdx, setActiveIdx] = useState(0);
  const [displayMonth, setDisplayMonth] = useState(moment().format("MMM YYYY"));

  const DAY_LABELS = ["M", "T", "W", "T", "F", "S", "S"];

  const buildWeek = (date) => {
    const startOfWeek = moment(date).startOf("isoWeek");
    return Array.from({ length: 7 }, (_, i) => moment(startOfWeek).add(i, "days").format("D"));
  };

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const date = urlParams.get("date") || today;
    setSelectedDate(date);
    setDisplayMonth(moment(date).format("MMM YYYY"));
    setSlideD(buildWeek(date));
    onDateSelect(date);
  }, []);

  const handleDateChange = (e) => {
    const date = e.target.value;
    if (!date) return;
    setSelectedDate(date);
    setDisplayMonth(moment(date).format("MMM YYYY"));
    setSlideD(buildWeek(date));
    onDateSelect(date);
  };

  const handleDayClick = (dayNum, idx) => {
    const startOfWeek = moment(selectedDate).startOf("isoWeek");
    const newDate = moment(startOfWeek).add(idx, "days").format("YYYY-MM-DD");
    if (moment(newDate).isAfter(today)) return;
    setSelectedDate(newDate);
    setActiveIdx(idx);
    onDateSelect(newDate);
  };

  return (
    <div className="calendar-home">
      <div className="calendar-month-picker">
        <input
          type="date"
          value={selectedDate}
          onChange={handleDateChange}
          max={today}
          className="calendar-input"
        />
        <span className="calendar-month-label">{displayMonth}</span>
      </div>
      <div className="calendar-week">
        {slideD.map((date, idx) => {
          const weekStart = moment(selectedDate).startOf("isoWeek");
          const dayDate = moment(weekStart).add(idx, "days").format("YYYY-MM-DD");
          const isFuture = moment(dayDate).isAfter(today);
          const isSelected = selectedDate === dayDate;
          const cls = isFuture ? "day-inactive" : isSelected ? "day-active" : "day-visited";
          return (
            <div
              key={idx}
              className={`calendar-day ${cls}`}
              onClick={() => !isFuture && handleDayClick(date, idx)}
            >
              <span className="day-label">{DAY_LABELS[idx]}</span>
              <span className="day-num">{date}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default CalendarHome;
